import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.AuditLogsServiceProxy,
        ApiServiceProxies.PassengerServiceProxy,
        ApiServiceProxies.PassengerTagServiceProxy,
        ApiServiceProxies.PassportServiceProxy,
        ApiServiceProxies.AgentServiceProxy,
        ApiServiceProxies.SupplierServiceProxy,
        ApiServiceProxies.ScannedPassportsServiceProxy,
        ApiServiceProxies.AppSettingsServiceProxy,
        ApiServiceProxies.AppSettingOptionsServiceProxy,
        ApiServiceProxies.BookingTransactionServiceProxy,
        ApiServiceProxies.BookingServiceProxy,
        ApiServiceProxies.BookingGeneratorServiceProxy,
        ApiServiceProxies.PackageServiceProxy,
        ApiServiceProxies.PurchaseOrderServiceProxy,
        ApiServiceProxies.StatementOfAccountServiceProxy,
        ApiServiceProxies.TravelServiceProxy,
        ApiServiceProxies.AccountingGeneratorServiceProxy,
        ApiServiceProxies.AnalyticsServiceProxy,
        ApiServiceProxies.CustomerBookingServiceProxy,
        ApiServiceProxies.TourInquiryServiceProxy,
        ApiServiceProxies.NewsletterSubscriberServiceProxy,
        ApiServiceProxies.CmsPageServiceProxy,
        ApiServiceProxies.CmsPublicServiceProxy,
        ApiServiceProxies.GlobalSettingsServiceProxy,
        ApiServiceProxies.CmsServiceProxy,
        ApiServiceProxies.CmsBackofficeServiceProxy,
        ApiServiceProxies.CmsFileUploadServiceProxy,
        ApiServiceProxies.BookingModuleSettingsServiceProxy,
        ApiServiceProxies.HotelBedsContentSyncServiceProxy,
        ApiServiceProxies.ContactInquiryServiceProxy,
        ApiServiceProxies.Contact_inquiriesServiceProxy,
        ApiServiceProxies.CheckoutServiceProxy,
        ApiServiceProxies.StaysServiceProxy,
        ApiServiceProxies.Cancellation_requestsServiceProxy,

        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
